import axios from 'axios';
import { apiUrls } from 'config';
import {
  AgendarCitaFormParams,
  AgendarCitaParams,
  Botiquin,
  ConsultaExamenesPrams,
  ConsultaMedicamentosFormParams,
  ContactFormParams,
  HistorialCitasFormParams,
  Receta,
  RecordatorioParams,
  ValidateDateParams,
  ValidateDoctorDateParams,
  AgendarCitaDoctorParams,
  Parametros,
} from './interfaces';

export class API {
  private static http = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  static sendMessage(params: ContactFormParams) {
    try {
      return this.http({
        params,
        method: 'POST',
        url: apiUrls.contactForm,
      });
    } catch (error) {
      console.error('Send Message Error', error);
      throw error;
    }
  }

  static getInfoReceta(params: ConsultaMedicamentosFormParams) {
    return this.http({
      params,
      method: 'POST',
      url: apiUrls.medicamentos,
      validateStatus: () => true,
    });
  }

  static getBotiquines(idMedicamento: string, log: number, cantidad: number) {
    return this.http({
      method: 'POST',
      url: apiUrls.botiquines,
      params: { idMedicamento, log, respuesta: 'SI', cantidad },
    });
  }

  static validateAfiliado(params: AgendarCitaFormParams) {
    return this.http({
      params,
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.consultaAfiliado,
    });
  }

  static setCita(params: AgendarCitaParams) {
    return this.http({
      params,
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.agendarCita,
    });
  }

  static setCitaDoctor(params: AgendarCitaDoctorParams) {
    return this.http({
      params,
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.agendarCitaDoctor,
    });
  }

  static setRecorgatorio(params: RecordatorioParams) {
    return this.http({
      params,
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.recordatorio,
    });
  }

  static validateDate(params: ValidateDateParams) {
    return this.http({
      params,
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.validateDate,
    });
  }

  static validateDoctorDate(params: ValidateDoctorDateParams) {
    return this.http({
      params,
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.validateDoctorDate,
    });
  }

  static getFaqs() {
    return this.http({
      method: 'POST',
      validateStatus: () => true,
      url: apiUrls.getFaqs,
    });
  }

  static reservarMedicamento(botiquin: Botiquin, receta: Receta) {
    return this.http({
      method: 'POST',
      url: apiUrls.reservaMedicamento,
      params: {
        idBotiquin: botiquin.idBotiquin,
        idEstablecimiento: botiquin.idEstablecimiento,
        idMedicamento: receta.idMedicamento,
        cantidadSolicitada: receta.cantidad,
        dui: receta.dui,
        idAfiliado: receta.idAfiliado,
        numReceta: receta.numReceta,
      },
    });
  }

  static consultaReserva(params: ConsultaMedicamentosFormParams) {
    return this.http({
      method: 'POST',
      url: apiUrls.consultaReserva,
      params: {
        dui: params.dui,
        idAfiliado: params.afiliado,
        numReceta: params.receta,
      },
    });
  }

  static getCitas(params: HistorialCitasFormParams) {
    return this.http({
      method: 'POST',
      url: apiUrls.listaCitas,
      params: {
        dui: params.dui,
        idAfiliado: params.afiliado,
      },
    });
  }

  static cancelarCita(idCita: string) {
    return this.http({
      method: 'POST',
      url: apiUrls.cancelarCita,
      params: { idCita },
    });
  }

  static consultaExamenes(params: ConsultaExamenesPrams) {
    return this.http({
      params,
      method: 'POST',
      url: apiUrls.consultaExamenes,
    });
  }

  static resultadosExamenes(id: number) {
    return this.http({
      params: { id },
      method: 'POST',
      url: apiUrls.resultadoExamenes,
    });
  }

  static getEspecialistas() {
    return this.http({
      method: 'POST',
      url: apiUrls.getEspecialistas,
    });
  }

  static getEstablecimientos() {
    return this.http({
      method: 'POST',
      url: apiUrls.getEstablecimientos,
    });
  }

  static getMedicos(idEspecialidad?: number) {
    return this.http({
      params: { idEspecialidad },
      method: 'POST',
      url: apiUrls.getMedicos,
    });
  }

  static getParametros(parametro: string) {
    const params = new URLSearchParams();
    params.append('parametro', parametro);

    return this.http({
      method: 'POST',
      url: apiUrls.getParametros,
      data: params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }

  static getReporteConfig(tipo: string) {
    return this.http({
      method: 'GET',
      url: `${apiUrls.reporteConfig}/${tipo}`,
      validateStatus: () => true,
    });
  }

  static getReportePdf(tipo: string, token: string) {
    return this.http({
      method: 'GET',
      url: `${apiUrls.reportePdf}/${tipo}/${token}`,
      responseType: 'blob',
      validateStatus: () => true,
    });
  }

  static getVerificacionReferencia(token: string) {
    return this.http({
      method: 'GET',
      url: `${apiUrls.referenciaVerificacion}/${encodeURIComponent(token)}`,
      validateStatus: () => true,
    });
  }

}
